import AboutModal from './AboutModal.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import DataSourceConfiguration from './DataSourceConfiguration.json';
import DatePicker from './DatePicker.json';
import ErrorBoundary from './ErrorBoundary.json';
import Header from './Header.json';
import HotkeysValidators from './HotkeysValidators.json';
import MeasurementTable from './MeasurementTable.json';
import Messages from './Messages.json';
import Modals from './Modals.json';
import Modes from './Modes.json';
import Notification from './Notification.json';
import PatientInfo from './PatientInfo.json';
import SegmentationTable from './SegmentationTable.json';
import SidePanel from './SidePanel.json';
import StudyBrowser from './StudyBrowser.json';
import StudyItem from './StudyItem.json';
import StudyList from './StudyList.json';
import ThumbnailTracked from './ThumbnailTracked.json';
import TooltipClipboard from './TooltipClipboard.json';
import TrackedCornerstoneViewport from './TrackedCornerstoneViewport.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';
import WindowLevelActionMenu from './WindowLevelActionMenu.json';

const viBundle = {
  AboutModal,
  Buttons,
  CineDialog,
  Common,
  DataSourceConfiguration,
  DatePicker,
  ErrorBoundary,
  Header,
  HotkeysValidators,
  MeasurementTable,
  Messages,
  Modals,
  Modes,
  Notification,
  PatientInfo,
  SegmentationTable,
  SidePanel,
  StudyBrowser,
  StudyItem,
  StudyList,
  ThumbnailTracked,
  TooltipClipboard,
  TrackedCornerstoneViewport,
  UserPreferencesModal,
  ViewportDownloadForm,
  WindowLevelActionMenu,
};

export default {
  vi: viBundle,
  'vi-VN': viBundle,
};
